import React, { useState } from 'react';
import { Form, Input, Button, message, Spin, Select } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { createGHGMethodology } from '../../../api/ghg';
import './create.css';

const CreateGHGMethodologyComponent: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await createGHGMethodology(values);
      message.success({
        content: 'GHG methodology created successfully',
        duration: 4,
        style: { textAlign: 'right' },
      });
      navigate('/ghg_methodologies');
    } catch (error: any) {
      console.error('Error creating GHG methodology:', error);
      message.error({
        content: error.message,
        duration: 4,
        style: { textAlign: 'right' },
      });
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error('Failed:', errorInfo);
  };

  return (
    <div className="create-ghg-methodology-container">
      <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />} fullscreen />
      <div className="form-container">
        <h1>Create GHG Methodology</h1>
        <Form
          name="createGHGMethodologyForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please input the name of the GHG methodology!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Short Display Name"
            name="code"
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Include in Project Screener"
            name="include_in_project_screener"
            initialValue="No"
          >
            <Select options={[{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }, { value: null, label: '-' }]} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Create
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default CreateGHGMethodologyComponent;
